import * as React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { Grid, Typography } from "@mui/material";

export default function LinkPreviewSkeleton() {
  return (
    <Box
      sx={{
        width: 300,
        border: "1px solid #ddd",
        borderRadius: 2,
        padding: 1,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {/* Image Skeleton */}
      <Skeleton variant="rectangular" width="100%" height={150} />

      {/* Text Skeletons */}
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="100%" />
    </Box>
  );
}
